import { Grid2 } from '@mui/material';
import React, { useMemo, useState } from 'react'; 
import CardAdministrador from '../../../../components/ui/materialui/cardAdministrador';
import { BrightnessHigh, FactCheck, Info, BlockRounded } from '@mui/icons-material';
import ModalBloqueoRecaudacion from '../components/ModalBloqueoRecaudacion';
import { usePermissions } from '../../../../components/auth/ProtectedRoute'; 
import { TipoFuncionalidad } from '../../../../utils/enums'; 

const AdministracionRemesas: React.FC = () => {
    const { hasPermission } = usePermissions();
    const [showModalBloq, setShowModalBloq] = useState(false);

    const linksPermitidos = useMemo(() => {
        const todosLosLinks = [
            { 
                fun: () => setShowModalBloq(true), 
                icon: <BlockRounded sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Administrar proceso recaudación",
                permission: TipoFuncionalidad.Remesas_ADM 
            },
            { 
                to: "/remesas/consultar", 
                icon: <FactCheck sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Consultar remesas",
                permission: TipoFuncionalidad.Remesas_ADM 
            },
            { 
                to: "/remesas/informeDesg", 
                icon: <Info sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Informe desgravamen",
                permission: TipoFuncionalidad.Remesas_ADM 
            },
        ];

        return todosLosLinks.filter(link => hasPermission(link.permission));
    }, [hasPermission]); 

    if (linksPermitidos.length === 0) return null;

    return (
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                <CardAdministrador
                    title="Remesas"
                    icon={<BrightnessHigh sx={{ fontSize: 20, color: "white" }} />}
                    links={linksPermitidos} 
                    backgroundColor="#17c2e6"
                    linkTextColor="text-info"
                />             
                {showModalBloq && (
                    <ModalBloqueoRecaudacion 
                        show={showModalBloq} 
                        setShow={setShowModalBloq} 
                        key={'ModalBlock'} 
                    />
                )}
            </Grid2>
        </Grid2 >
    );
};

export default AdministracionRemesas;